import React from "react";

const RatingButtons = ({formik, name, nuOptions = 11, label}) => {

    const {errors, touched, values, setFieldValue} = formik;

    return <div className="overview-content sl-flex sl-flex-col">


        <div
            className={`sl-bg-gray-100 overview-hero sl-inline-flex sl-justify-between sl-w-full sl-rounded-lg  sl-pt-12 sl-pb-12 sl-pl-20 sl-pr-20
            ${touched[name] && errors[name] ? 'sl-border-1 sl-border-solid sl-border-error-300' : ''}
                `}>
            <div className="sl-display-flex ">
                <span
                    className="sl-m-auto sl-f sl-text-sm sl-font-semibold sl-text-gray-700 sl-font">{label}</span>
            </div>

            <div className="sl-display-flex sl-gap-1">
                {[...Array(nuOptions)].map((item, index) => <button
                    key={index}
                    onClick={() => setFieldValue(name, index)}
                    className={`sl-btn ${index !== values[name] ? 'sl-btn-tertiary' : 'sl-btn-primary'} sl-btn-lg sl-rounded-lg sl-font sl-w-10 sl-h-9 sl-p-0`}>
                    {index}
                </button>)}
            </div>
        </div>
        {touched[name] &&
        <span className="sl-text-error-500 sl-mt-2 sl-font sl-text-sm">{errors[name]}</span>}
    </div>
}

export default RatingButtons;